var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center",attrs:{"id":"cell-renderer-history"}},[_c('div',[_c('div',{staticClass:"label-created"},[_vm._v(_vm._s(_vm.created))]),_c('div',{staticClass:"label-history"},[_vm._v("\n      "+_vm._s(_vm.params.value.name)+"さんが"+_vm._s(_vm.params.value.action)+"しました。\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }